import { createContext, useContext } from 'react'

export interface SessionExpiredContextValue {
    /**
     * Whether the session has expired during runtime.
     * This is set to true when a 401 response is received from the API.
     */
    isSessionExpired: boolean
}

export const SessionExpiredContext = createContext<SessionExpiredContextValue | undefined>(
    undefined,
)

export function useSessionExpired(): SessionExpiredContextValue {
    const context = useContext(SessionExpiredContext)

    if (context === undefined) {
        throw new Error('useSessionExpired must be used within SessionExpiredProvider')
    }

    return context
}
